export const ajax = {
        url: 'https://www.novoferm-extranet.de/'};



// WEBPACK FOOTER //
// ./src/Context.js